import { BrowserView, isMobile, MobileView } from 'react-device-detect';
import styles from './HotpleItem.module.css';
import LazyLoad from 'react-lazyload';
import { copyToClipboard, haversineDistance, openInstagramMedia } from '../../../../../../../util';


const HotpleItem = ({hotple, activeMenu, updateHotpleInfo, setSelectedHotple, isSelected, hotThreshold, devicePosition, setAnlysisPageHotple}) => {
	if (!hotple)
        return null;

	const { start_date, end_date, mention_count, created_at, has_comment_event, uploaded_at } = hotple;
	let badge = null;

	if (has_comment_event && uploaded_at && (new Date(uploaded_at) >= new Date(Date.now() - 7 * 24 * 60 * 60 * 1000))) {
		badge = <div className={styles.periodBadge}>댓글 이벤트</div>;
	} else if (start_date && new Date(start_date) > new Date()) {
		badge = <div className={styles.endBadge}>시작예정</div>;
	} else if (end_date && new Date(end_date) < new Date()) {
		badge = <div className={styles.endBadge}>종료됨</div>;
	} else if (end_date && new Date(end_date) < new Date(Date.now() + 3 * 24 * 60 * 60 * 1000)) {
		badge = <div className={styles.periodBadge}>종료임박</div>;
	} else if (mention_count > hotThreshold) {
		badge = <div className={styles.hotBadge}>HOT</div>;
	} else if (new Date(created_at) >= new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)) {
		badge = <div className={styles.newBadge}>NEW</div>;
	}

	const patchIsPick = () => {
		const updatedHotple = {
			...hotple,
			is_pick: !hotple.is_pick,
			mention_count: hotple.mention_count + (!hotple.is_pick ? 1 : -1)
		};

		updateHotpleInfo('updateIsPick', updatedHotple);
	};

	const whenHotpleClicked = () =>{
		if(!isSelected){
			setSelectedHotple(null);
			setTimeout(() => {
				setSelectedHotple(hotple);
			}, 50);
		}
		else{
			whenAnalysisClicked();
		}
	};

	const whenImageClicked = (event) =>{
		event.stopPropagation();
		openInstagramMedia(hotple.media_url);

		if(!isSelected){
			setSelectedHotple(null);
			setTimeout(() => {
				setSelectedHotple(hotple);
			}, 50);
		}
	};

	const whenImageEditButtonClicked = () => {
		updateHotpleInfo('showImageEditHotpleModal', hotple);
	};

	const whenAnalysisClicked = () => {
		if((hotple.key_features && hotple.key_features.length>0) || (hotple.positive_summary && hotple.positive_summary.length>0)){
			setSelectedHotple(hotple);
			setAnlysisPageHotple(hotple);
		}
	};

	const whenRightButtonClicked = () => {
		if(hotple.need_verify)
			updateHotpleInfo('showVerifyHotpleModal', hotple);
		else
			updateHotpleInfo('showEditHotpleModal', hotple);
	};

	function handleVerifyResultButtonClicked() {
		updateHotpleInfo('showEditRequestModal', hotple);
	}

  	return (
		<div className={(activeMenu=='my' || activeMenu=='admin') ? styles.myHotpleItem : styles.nearbyHotpleItem} onClick={whenHotpleClicked} data-status={isMobile? false : isSelected}>
			{(activeMenu=='my' || activeMenu=='admin') &&
				<div className={styles.iconcloseLineParent}>
					{activeMenu=='admin' &&
					<>
						<span className={styles.idText} onClick={(event)=>{event.stopPropagation();copyToClipboard(hotple.hotple_id);}}>{hotple.hotple_id}:</span>
						<span className={styles.mediaText} onClick={(event)=>{event.stopPropagation();copyToClipboard(hotple.media_id);}}>{hotple.media_id}</span>
					</>
					}
					<img className={styles.iconcloseLine} onClick={(event)=> {event.stopPropagation(); updateHotpleInfo((activeMenu=='admin'?"showDeleteHotpleModal":'showDeleteMyHotpleModal'),hotple);}} alt="" src="images/close_line.svg" />
				</div>
			}

			{activeMenu == 'admin' && hotple.verify_results && hotple.verify_results.filter(verify_result => verify_result.need_check).length>0 &&
				<div className={styles.editrequestframe}>
					<div className={styles.editrequesttitle}>수정 요청:</div>
					{hotple.verify_results
						.filter(verify_result => verify_result.need_check) // need_check가 true인 객체만 필터링
						.map((verify_result, index) => (
							<div 
								key={index} 
								className={styles.editrequstbutton} 
								onClick={() => handleVerifyResultButtonClicked(verify_result)} // 버튼 클릭 시 함수 호출
								>
								<div className={styles.editrequestnumber}>{index + 1}</div> {/* 인덱싱하여 1부터 표시 */}
							</div>
						))
					}
				</div>
			}
			<BrowserView style={{width:'100%'}}>
				<div className={styles.imageframe}>
					<div className={styles.padding1}/>
					<div className={styles.image1frame} onClick={whenImageClicked}>
						<LazyLoad height={152} offset={333} once scrollContainer="#hotpleitems-container">
							<img className={styles.image1Icon} alt="" src={hotple.contents_url && hotple.contents_url[0] ? (hotple.contents_url[0].includes("mp4") ? (hotple.preview_url || "images/no_instagram_image.svg") : hotple.contents_url[0]) : (hotple.preview_url || "images/no_instagram_image.svg")} />
						</LazyLoad>
						{hotple.media_url &&
						<>
							<div className={styles.infoframe}>
								{
									hotple.media_id[0].startsWith('H') ?
										<img className={styles.iconfire2} alt="" src="images/fire.svg" />
									:
										<img className={styles.iconinstagramColor} alt="" src="images/instagram.svg" />
								}
								<div className={styles.username}>@{hotple.media_creator}</div>
							</div>
						</>
						}
					</div>

					{hotple.contents_url && hotple.contents_url.length > 1 &&
						<div className={styles.image2frame} onClick={whenImageClicked}>
							<LazyLoad height={152} offset={333} once scrollContainer="#hotpleitems-container">
								<img className={styles.image1Icon} alt="" src={hotple.contents_url[1]} />
							</LazyLoad>
							{hotple.media_url &&
							<>
								<div className={styles.infoframe}>
									{
										hotple.media_id[0].startsWith('H') ?
											<img className={styles.iconfire2} alt="" src="images/fire.svg" />
										:
											<img className={styles.iconinstagramColor} alt="" src="images/instagram.svg" />
									}
									<div className={styles.username}>@{hotple.media_creator}</div>
								</div>
							</>
							}
						</div>
					}

					{hotple.contents_url && hotple.contents_url.length>2 ?
						<div className={styles.image2frame} onClick={whenImageClicked}>
							<LazyLoad height={152} offset={333} once scrollContainer="#hotpleitems-container">
								<img className={styles.image1Icon} alt="" src={hotple.contents_url[2]} />
							</LazyLoad>
							{hotple.media_url &&
							<>
								<div className={styles.infoframe2}>
									{
										hotple.media_id[0].startsWith('H') ?
											<img className={styles.iconfire2} alt="" src="images/fire.svg" />
										:
											<img className={styles.iconinstagramColor} alt="" src="images/instagram.svg" />
									}
									<div className={styles.username}>@{hotple.media_creator}</div>
								</div>
								
								<div className={styles.infos}>
									<b className={styles.imagenum}>+{hotple.contents_url.length-2}장</b>
									<div className={styles.div}>
										<span className={styles.txt}>
												<p className={styles.p}>게시글</p>
												<p className={styles.p}>보러가기</p>
										</span>
									</div>
								</div>
							</>
							}
						</div>
						:
						<div className={styles.image2frame} onClick={whenImageClicked}>
							<LazyLoad height={152} offset={333} once scrollContainer="#hotpleitems-container">
								<img className={styles.image1Icon} alt="" src={hotple.contents_url && hotple.contents_url[1] ? (hotple.contents_url[1].includes("mp4") ? (hotple.preview_url || "images/no_instagram_image.svg") : hotple.contents_url[1]) : (hotple.preview_url || "images/no_instagram_image.svg")} />
							</LazyLoad>
							{hotple.media_url &&
							<>
								<div className={styles.infoframe2}>
									{
										hotple.media_id[0].startsWith('H') ?
											<img className={styles.iconfire2} alt="" src="images/fire.svg" />
										:
											<img className={styles.iconinstagramColor} alt="" src="images/instagram.svg" />
									}
									<div className={styles.username}>@{hotple.media_creator}</div>
								</div>
							
								<div className={styles.infos}>
									<img className={styles.iconshare} alt="" src="images/share.svg" />
									<div className={styles.div}>
										<span className={styles.txt}>
												<p className={styles.p}>게시글</p>
												<p className={styles.p}>보러가기</p>
										</span>
									</div>
								</div>
							</>
							}
						</div>
					}

					{(!hotple.contents_url || hotple.contents_url.length <= 1) &&
						((!hotple.preview_url || !hotple.contents_url || hotple.contents_url.length==0) && activeMenu=='admin' ?
							<div className={styles.image2frame} onClick={whenImageEditButtonClicked}>
								<div className={styles.infoframe3}/>
								<div className={styles.infos}>
									<img className={styles.iconshare2} alt="" src="images/search.svg" />
									<div className={styles.div}>
										<span className={styles.txt2}>
												<p className={styles.p}>이미지</p>
												<p className={styles.p}>정보확인</p>
										</span>
									</div>
								</div>
							</div>
						:
							<div className={styles.image2frame} onClick={whenHotpleClicked}/>
						)
					}
				</div>
			</BrowserView>

			<MobileView>
				<div className={styles.imageframe}>
					<div className={styles.padding}/>
					
					{hotple.contents_url && hotple.contents_url[0] ?
						hotple.contents_url[0].includes("mp4") ?
							<div className={styles.image1frame} onClick={whenImageClicked}>
								<LazyLoad height={152} offset={333} once scrollContainer="#hotpleitems-container">
									<img className={styles.image1Icon} alt="" src={hotple.preview_url || "images/no_instagram_image.svg"} />
								</LazyLoad>
								{hotple.media_id &&
									<div className={styles.infoframe}>
										{
											hotple.media_id?.[0]?.startsWith('H') ?
												<img className={styles.iconfire2} alt="" src="images/fire.svg" />
											:
												<img className={styles.iconinstagramColor} alt="" src="images/instagram.svg" />
										}
										<div className={styles.username}>@{hotple.media_creator}</div>
									</div>
								}
							</div>
						:
							hotple.contents_url.map((url, index) => (
								<div key={index} className={index == 0 ? styles.image1frame : styles.image2frame} onClick={whenImageClicked}>
									<LazyLoad height={152} offset={333} once scrollContainer="#hotpleitems-container">
										<img className={index == 0 ? styles.image1Icon : styles.image3Icon} alt="" src={url} />
									</LazyLoad>
									{hotple.media_id &&
										<div className={index == 0 ? styles.infoframe : styles.infoframe4}>
											{
												hotple.media_id?.[0]?.startsWith('H') ?
													<img className={styles.iconfire2} alt="" src="images/fire.svg" />
												:
													<img className={styles.iconinstagramColor} alt="" src="images/instagram.svg" />
											}
											<div className={styles.username}>@{hotple.media_creator}</div>
										</div>
									}
								</div>
							))
					:
						((!hotple.preview_url || !hotple.contents_url || hotple.contents_url.length==0) && activeMenu=='admin' ?
							<div className={styles.image2frame} onClick={whenImageEditButtonClicked}>
								<div className={styles.infoframe3}/>
								<div className={styles.infos}>
									<img className={styles.iconshare2} alt="" src="images/search.svg" />
									<div className={styles.div}>
										<span className={styles.txt2}>
												<p className={styles.p}>이미지</p>
												<p className={styles.p}>정보확인</p>
										</span>
									</div>
								</div>
							</div>
						:
							<div className={styles.image2frame} onClick={whenHotpleClicked}/>
						)
					}

					<div className={styles.image2frame} onClick={whenImageClicked}>
						<LazyLoad height={152} offset={333} once scrollContainer="#hotpleitems-container">
							<img className={styles.image2Icon} alt="" src={hotple.preview_url || "images/no_instagram_image.svg"} />
						</LazyLoad>
						{hotple.media_url &&
						<>
							<div className={styles.infoframe2}>
								{
									hotple.media_id[0].startsWith('H') ?
										<img className={styles.iconfire2} alt="" src="images/fire.svg" />
									:
										<img className={styles.iconinstagramColor} alt="" src="images/instagram.svg" />
								}
								<div className={styles.username}>@{hotple.media_creator}</div>
							</div>
						
							<div className={styles.infos}>
								<img className={styles.iconshare} alt="" src="images/share.svg" />
								<div className={styles.div}>
									<span className={styles.txt}>
											<p className={styles.p}>게시글</p>
											<p className={styles.p}>보러가기</p>
									</span>
								</div>
							</div>
						</>
						}
					</div>

					<div className={styles.padding}/>
				</div>
			</MobileView>
			
			<div className={styles.analysisParentFrame}>
				<div className={styles.analysisScrollFrame}>
					{hotple.key_features && hotple.key_features.length>0 && 
						<div className={styles.analysisFrame}>
							<div className={styles.padding1}/>
							<div className={styles.positive_text1} onClick={()=>whenAnalysisClicked()}>
								★{Math.floor(hotple.average_rating * 100) / 100}점
							</div>
							{hotple.key_features.map(item => (
								<div className={styles.positive_text0} onClick={()=>whenAnalysisClicked()}>
									{item}
								</div>
							))}
							<div className={styles.padding1}/>
						</div>
					}

					{hotple.positive_summary && hotple.positive_summary.length>0 && 
						<div className={styles.analysisFrame}>
							<div className={styles.padding1}/>
							<div className={styles.positive_text} onClick={()=>whenAnalysisClicked()}>
								긍정 {Math.floor(hotple.positive_ratio*100)}%
							</div>
							{hotple.positive_summary.map(item => (
								<div className={styles.positive_text0} onClick={()=>whenAnalysisClicked()}>
									"{item}"
								</div>
							))}
							<div className={styles.padding1}/>
						</div>
					}
				</div>
			</div>

			<div className={styles.detailframe}>
					<div className={styles.detailleft}>
						<div className={styles.title}>
								<div className={styles.hotplename}>{hotple.name}</div>
								{badge && <span className={styles.badgeWrapper}>{badge}</span>}
								{hotple.latitude && hotple.longitude && 
									<div className={styles.ratingframe}>
										<img className={styles.iconfire} alt="star" src="images/my_location.svg" />
										<div className={styles.ratingtext}>{Math.trunc(haversineDistance(devicePosition, {lat:hotple.latitude, long:hotple.longitude}) * 10) / 10}km</div>
									</div>
								}
						</div>
						<div className={styles.tags}>
								<div className={styles.tagplaceDetail}>
									<div className={styles.orange}>{hotple.main_category}</div>
								</div>
								<div className={styles.tagplaceDetail1}>
									<div className={styles.orange}>{hotple.sub_category1} ▸ {hotple.sub_category2}</div>
								</div>
								{hotple.tags && hotple.tags.slice(0, 3).map((tag, index) => (
									<div className={styles.tagplaceDetail2} key={index}>
										<div className={styles.orange}>#{tag}</div>
									</div>
								))}
						</div>
						<div className={styles.caption}>{hotple.caption}</div>
						{hotple.comment &&
							<div className={styles.commentframe}>	
									<div className={styles.label}>댓글</div>
									<div className={styles.comment}>
										{hotple.taggedBy!=null &&
											<a className={styles.taggedBy} href={`https://instagram.com/${hotple.taggedBy}`} target="_blank" rel="noopener noreferrer">@{hotple.taggedBy}: </a>
										}
										{hotple.comment.split(/(@[\w\.]+)/g).map((part, index) => {
											if (part.startsWith('@')) {
											// 유저 태그 부분 처리
											const username = part.slice(1); // '@' 제거한 유저 이름
											return (
												<a
												key={index}
												className={styles.commentUser}
												href={`https://instagram.com/${username}`}
												target="_blank"
												rel="noopener noreferrer"
												>
												{part}
												</a>
											);
											} else {
											// 일반 텍스트 처리
											return (
												<span key={index} className={styles.span}>
												{part}
												</span>
											);
											}
										})}
									</div>
							</div>
						}
						{hotple.has_period &&
							<div className={styles.commentframe}>
									<div className={styles.label}>기간</div>
									<div className={styles.period}>{hotple.start_date && hotple.start_date.replaceAll('-','/')} ~ {hotple.end_date && hotple.end_date.replaceAll('-','/')}</div>
							</div>
						}
					</div>
					{activeMenu=='search' || activeMenu=='home' ?
						<div className={styles.detailrightbutton} onClick={(event) => {event.stopPropagation(); patchIsPick();}}>
							{hotple.is_pick ?
								<img className={styles.iconlikeActive} alt="" src= {hotple.has_period ? "images/notification_active.svg" : "images/like_active.svg"} />
								:
								<img className={styles.iconlikeOutlined} alt="" src= {hotple.has_period ? "images/notification.svg" : "images/like_outlined.svg"} />
							}
							<div className={hotple.is_pick ? styles.is_pick : styles.not_pick}>PICK</div>
						</div>
					:
						<div className={styles.detailrightbutton} onClick={(event)=>{event.stopPropagation();whenRightButtonClicked();}}>
							{hotple.need_verify ?
								<img className={styles.iconlikeActive} alt="" src= "images/update.svg" />
								:
								<img className={styles.iconlikeOutlined} alt="" src= "images/pen.svg" />
							}
							<div className={hotple.need_verify ? styles.is_pick : styles.not_pick}> {hotple.need_verify ? "검토 필요" : "정보 수정"} </div>
						</div>
					}
			</div>
		</div>
	);
};

export default HotpleItem;